<template>
    <a
        v-bind="$attrs"
        class="search-result-opportunity"
        :data-bot="
            context ? `search-result__opportunity--${context}` : 'search-result__opportunity'
        "
        :class="classes"
        :href="link"
        @mouseenter="handleMouseEnter"
        @mouseleave="isHovered = false"
    >
        <CompassObject size="extra-small" type="object" object="opportunity" />
        <div class="search-result-opportunity__content">
            <div class="search-result-opportunity__title">
                <h5
                    class="search-result-opportunity__name typographies-paragraph-medium-bold"
                    v-html="name"
                />
                <div v-if="status" class="opportunity-status">
                    <CompassTag
                        size="small"
                        :color="statusInformation.color"
                        :icon="statusInformation.icon"
                    >
                        {{ status.label }}
                    </CompassTag>
                </div>
            </div>
            <ul class="search-result-opportunity__details typographies-paragraph-medium-regular">
                <li v-html="ident" />
                <li
                    class="typographies-paragraph-medium-semibold search-result-opportunity__company"
                >
                    <CompassLink
                        type="secondary"
                        :link="relatedObject.url"
                        v-html="relatedObject.name"
                    />
                </li>
                <li>{{ amount }}</li>
            </ul>
        </div>
    </a>
</template>
<script>
import { allStatus } from 'Dictionaries/statusColors';
import SearchResultsGeneric from './SearchResultsGeneric.vue';

export default {
    extends: SearchResultsGeneric,
    props: {
        amount: {
            type: String,
            required: true,
        },
        ident: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        related: {
            type: Object,
            required: true,
        },
        status: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        statusInformation() {
            return allStatus[this.status.id];
        },
        relatedObject() {
            return {
                name:
                    this.related.type === 'individual'
                        ? `${this.related.first_name} ${this.related.last_name}`
                        : this.related.name,
                url: this.related.link,
            };
        },
        classes() {
            return {
                'search-result-opportunity--is-hovered': this.isHovered,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.search-result-opportunity {
    align-items: flex-start;
    cursor: pointer;
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-3);

    &--is-hovered {
        background: var(--colors-common-background-hover, #f6f6f9);
    }

    &__title {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
    }

    .opportunity-status {
        color: var(--colors-common-text-standard-default, #111);
    }

    :deep(.compass-link) {
        display: inline;
    }

    :deep(.compass-object) {
        flex-shrink: 0;
    }

    &__company {
        flex-shrink: 0;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__name {
        color: var(--colors-common-text-standard-default, #111);
        margin: 0;
    }

    &__details {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-2);
        margin: var(--spacing-0) 0 0;
    }

    :deep(.highlight) {
        background: var(--colors-common-background-highlight-search);
    }
}
</style>
